/*
 * The Southern Air Import on phones: turn pages by swiping. Pairs with
 * assets/sat-import-mobile.css and the data-m hooks from
 * assets/sat-import-template-patch.js.
 *
 * Used to also compute --sai-zoom, a scale factor that shrank the whole
 * 980px desktop page to fit the phone's screen width (a photo of the
 * desktop page, in effect). assets/sat-import-mobile.css no longer scales
 * pages that way — it reflows each one as a real responsive layout instead
 * — so there's nothing left here to size; --sai-zoom is gone along with the
 * resize/orientationchange listeners that only existed to keep it current.
 *
 * - Swipe left = Next Page, swipe right = Prev Page (on the closed cover,
 *   swipe left opens the issue). Presses the Import's own buttons, so page
 *   logic, sounds and the back cover all behave exactly as when tapped.
 *   Ignored while the reader is pinch-zoomed in, so panning a zoomed page
 *   never turns it, and ignored for mostly-vertical gestures.
 * - Page turns on phones land on the top of the magazine, not the top of
 *   the site (see the scrollTo note below).
 */
(function () {
  'use strict';
  var root = document.documentElement;

  function visible(sel) {
    var list = document.querySelectorAll(sel), i;
    for (i = 0; i < list.length; i++) { if (list[i].offsetParent !== null) return list[i]; }
    return null;
  }
  function zoomedIn() {
    return !!(window.visualViewport && window.visualViewport.scale > 1.05);
  }


  // Page turns call window.scrollTo(0, 0), which on a phone throws the reader
  // back up past the header to the top of the site on every swipe. On phones,
  // while the Import is open (not the home page teaser), land on the top of
  // the magazine instead. Checked two frames later, after the app re-renders,
  // so a turn that navigates somewhere else entirely still goes to the top.
  var nativeScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function (x, y) {
    nativeScrollTo.apply(window, arguments);
    if (arguments.length !== 2 || x !== 0 || y !== 0) return;
    if ((root.clientWidth || window.innerWidth) > 900) return;
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var store = document.getElementById('store');
      if (!store || store.offsetParent === null) return;
      if (visible('[data-m="hero-grid"]')) return; // home page: leave it alone
      var top = store.getBoundingClientRect().top + window.pageYOffset;
      nativeScrollTo(0, Math.max(0, top));
    }); });
  };

  var sx = 0, sy = 0, st = 0, tracking = false;
  document.addEventListener('touchstart', function (e) {
    tracking = false;
    if (!e.touches || e.touches.length !== 1 || zoomedIn()) return;
    var store = document.getElementById('store');
    if (!store || store.offsetParent === null || !store.contains(e.target)) return;
    if (e.target.closest && e.target.closest('input,select,textarea')) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); tracking = true;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!tracking) return;
    tracking = false;
    if (zoomedIn() || !e.changedTouches || !e.changedTouches.length) return;
    var dx = e.changedTouches[0].clientX - sx;
    var dy = e.changedTouches[0].clientY - sy;
    if (Date.now() - st > 700) return;
    if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var btn = dx < 0 ? (visible('[data-m="sai-next"]') || visible('[data-m="sai-open"]')) : visible('[data-m="sai-prev"]');
    if (btn) { btn.click(); }
  }, { passive: true });
})();
